import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';

import rules from '../../../common/rules/rules';
import accountRules from '../../../common/rules/accountRules';
import { PasswordInput } from '../../../common/components';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';

const { Item: FormItem } = Form;

window.recaptchaOptions = {
  enterprise: true,
};

@translate()
@Form.create()
export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: '',
      refreshReCaptcha: 0,
      loadingCaptchaToken: false,
      formSubmitted: false,
    }
  }

  static propTypes = {
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.props;
    form.validateFields((err, values) => {
      if (!err) {

        this.setState((prevstate) => {
          return { 
            refreshReCaptcha: prevstate.refreshReCaptcha + 1,
            loadingCaptchaToken: true,
            formSubmitted: true,
          }
        })
      }
    });
  };

  onVerifyCaptcha = (token) => {
    const { form, onSubmit } = this.props;

    if (token) {
      this.setState({
        token: token,
        loadingCaptchaToken: false,
      });

      if (this.state.formSubmitted) {
        form.validateFields((err, values) => {
          if (!err) {
            onSubmit({
              email: values.email,
              password: values.password,
              captchaToken: token
            });
          }
        });
      }
    }
  }

  render() {
    const { form, t } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Spin spinning={this.state.loadingCaptchaToken}>
      <Grid className="auth-wrapper">
        <Row between="xs" middle="sm">
          <Col xs={12} sm={6}>
            <h2>{t('Prihlásenie')}</h2>
            <Form layout="vertical" onSubmit={this.handleSubmit} hideRequiredMark noValidate>
              <FormItem label={t('E-mail')}>
                {getFieldDecorator('email', {
                  rules: accountRules.email,
                  validateTrigger: 'onChange',
                })(<Input size="default" placeholder={t('E-mail')} autoFocus type="email" />)}
              </FormItem>
              <FormItem label={t('Heslo')}>
                {getFieldDecorator('password', { rules: rules.required })(
                  <PasswordInput placeholder={t('Heslo')} />
                )}
              </FormItem>
              <Row between="xs" middle="xs" className="form-actions">
                <Col xs={12} sm={6}>
                  <Button type="primary" className="btn-block" htmlType="submit" size="default">
                    {t('Prihlásiť')}
                  </Button>
                </Col>
                <Col xs={12} sm={6} className="text-right">
                  <Link to="auth/forgotten-password">{t('Zabudli ste heslo?')}</Link>
                </Col>
              </Row>
              <GoogleReCaptcha 
                onVerify={this.onVerifyCaptcha}
                language="sk"
                sitekey={process.env.REACT_APP_SITE_KEY}
                refreshReCaptcha={this.state.refreshReCaptcha}
              />
            </Form>
          </Col>
          <Col xs={12} sm={6} md={5} mdOffset={1} className="info-block">
            <p>{t('Investovanie alebo pôžička cez Majak.sk? Tu je pár dôvodov:')}</p>
            <ul>
              <li>{t('vyšší výnos ako pri vklade v banke')}</li>
              <li>{t('nižší úrok ako pri úvere v banke')}</li>
              <li>{t('bez zbytočného papierovania')}</li>
              <li>{t('online prehľad o investícii alebo pôžičke')}</li>
              <li>{t('bez skrytých poplatkov a nefér podmienok')}</li>
            </ul>
          </Col>
        </Row>
      </Grid>
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/components/LoginForm.js